import { Form, Input, Select, Typography } from 'antd';
import * as Component from 'components';
import { BASE_URL } from 'constants/api';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { playlistApiService } from '../services/playlistApiService';
import { PlaylistInterface } from '../types/playlistType';
import './PlaylistDetail.css';

const { Text, Link } = Typography;
const MRSS_URL_FORMAT = `${BASE_URL}/api/v1/playlist/{id}/mrss/{service_name}`;

export const PlaylistDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [playlistData, setPlaylistData] = useState<PlaylistInterface>();
  const navigate = useNavigate();

  const fetchPlaylist = async (): Promise<void> => {
    const playlist = await playlistApiService.fetchById(Number(id));
    form.setFieldsValue(playlist);
    setPlaylistData(playlist);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchPlaylist().then();
  }, [id, form]);

  return (
    <>
      {isLoading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <div>
          <div className="playlist-details-page">
            <Form
              form={form}
              layout="vertical"
              className="playlist-details-form"
              initialValues={playlistData}
            >
              <Form.Item name="title" label="Title">
                <Input />
              </Form.Item>
              <Form.Item name="description" label="Description">
                <Input />
              </Form.Item>
              <Form.Item name="type" label="Type" rules={[{ required: true }]}>
                <Select
                  options={[
                    { value: 'manual', label: 'manual' },
                    { value: 'dynamic', label: 'dynamic' },
                  ]}
                  disabled={true}
                />
              </Form.Item>
              <Form.Item name="created" label="Created">
                <Input readOnly />
              </Form.Item>
            </Form>
          </div>

          <div>
            <div className="playlist-sources">
              <h3>Playlist MRSS Sources</h3>
            </div>
            <div className="playlist-mrss" style={{ marginTop: '30px' }}>
              <Text strong style={{ marginLeft: '30px', marginRight: '10px' }}>
                Zype MRSS Feed URL:
              </Text>
              <Link
                href={MRSS_URL_FORMAT.replace('{id}', String(id)).replace('{service_name}', 'zype')}
                target="_blank"
              >
                {MRSS_URL_FORMAT.replace('{id}', String(id)).replace('{service_name}', 'zype')}
              </Link>
              <br />
              <Text strong style={{ marginLeft: '30px', marginRight: '10px' }}>
                Amagi MRSS Feed URL:
              </Text>
              <Link
                href={MRSS_URL_FORMAT.replace('{id}', String(id)).replace(
                  '{service_name}',
                  'amagi'
                )}
                target="_blank"
              >
                {MRSS_URL_FORMAT.replace('{id}', String(id)).replace('{service_name}', 'amagi')}
              </Link>
              <br />
              <Text strong style={{ marginLeft: '30px', marginRight: '10px' }}>
                Xumo MRSS Feed URL :
              </Text>
              <Link
                href={MRSS_URL_FORMAT.replace('{id}', String(id)).replace('{service_name}', 'xumo')}
                target="_blank"
              >
                {MRSS_URL_FORMAT.replace('{id}', String(id)).replace('{service_name}', 'xumo')}
              </Link>
            </div>
          </div>
          <div className="playlist-detail-update-button" style={{ marginTop: '30px' }}>
            <Component.ColorButtonComponent
              text={'Update'}
              onClick={async () => {
                const newPlaylist = form.getFieldsValue();
                await playlistApiService.update(Number(id), newPlaylist);
                navigate('/playlists/');
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
